import FilterListIcon from '@mui/icons-material/FilterList' // Custom Filters Icon
import { Badge, Box, IconButton, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material'

const slotProps = (theme, badgeColor) => ({
  sx: {
    borderRadius: 2,
    maxHeight: '100%',
    mt: 2,
    mb: 2,
    '&:hover': { backgroundColor: theme.palette.mode === 'dark' ? theme.palette.primary.main : 'rgba(0,0,0,0.1)' },
    color: theme.palette.text.primary,
    '& .MuiBadge-badge': {
      backgroundColor: badgeColor ?? 'rgb(205, 254, 194)', // Your custom background color
      color: theme.palette.mode === 'dark' ? 'rgba(0,0,0,1)' : 'rgba(0,0,0,1)', // Change the text color if needed
      fontSize: '14px', // Optional: adjust the font size
      width: '20px', // Adjust the width/height to control the size of the badge
      height: '20px',
    },
  },
})

const OpenFiltersMenu = ({ onOpenFilters, filterModel, badgeColor }) => {
  const theme = useTheme()
  const isExtraLargeScreen = useMediaQuery(theme.breakpoints.up('xl'))
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'))
  const isMediumScreen = useMediaQuery(theme.breakpoints.up('md'))
  const isSmallScreen = useMediaQuery(theme.breakpoints.up('sm'))

  return (
    <Box sx={{ ...slotProps(theme, badgeColor), display: 'flex', alignItems: 'center', gap: 2 }}>
      <Badge
        badgeContent={
          <>
            {filterModel && filterModel.items && Array.isArray(filterModel.items) && filterModel.items.length > 0 ? (
              <Typography
                sx={{
                  fontSize: 14,
                  color: badgeColor,
                  p: 0.5,
                  height: '20px',
                  width: '20px',
                  borderRadius: '50%',
                  display: 'flex', // Flexbox centering
                  alignItems: 'center', // Vertically center
                  justifyContent: 'center', // Horizontally center
                  fontWeight: 'bold',
                }}
              >
                {filterModel && filterModel.items && Array.isArray(filterModel.items) ? filterModel.items.length : null}
              </Typography>
            ) : null}
          </>
        }
        sx={{
          '.MuiBadge-badge': {
            minWidth: 16,
            height: 16,
            fontSize: '10px',
            padding: 0,
            transform: 'translate(8px, -6px)', // Moves the badge closer to the icon
          },
        }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Tooltip title="Filters">
          <IconButton
            sx={{
              height: 35,
              width: 35,
              borderRadius: '0px',
              '&:hover': {
                backgroundColor: theme.palette.mode === 'dark' ? theme.palette.primary.main : 'rgba(0,0,0,0.1)',
              },
            }}
            onClick={onOpenFilters}
          >
            <FilterListIcon
              sx={{
                fontSize: '30px',
              }}
            />
          </IconButton>
        </Tooltip>
      </Badge>
    </Box>
  )
}

export default OpenFiltersMenu
